module.exports = __webpack_public_path__ + "media/images/icons/outlined/android-e70bf97f7aa6169da0886019cacb63b2.svg";